import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { ChatMessage, ChatResponse, ChatContext } from './ai-chat.types';

@Injectable({
  providedIn: 'root'
})
export class AiChatService {
  private apiEndpoint = '/aiAgent/chat'; // Backend endpoint
  private isConnected$ = new BehaviorSubject<boolean>(false);
  
  constructor(private http: HttpClient) {}

  sendMessage(message: string, chatId: string, context?: ChatContext): Observable<ChatResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const payload = {
      message,
      chatId,
      context
    };

    return this.http.post<ChatResponse>(this.apiEndpoint, payload, { headers });
  }

  getConnectionStatus(): Observable<boolean> {
    return this.isConnected$.asObservable();
  }

  testConnection(): Observable<any> {
    return this.http.get(`${this.apiEndpoint}/status`);
  }
}